import React, { useEffect, useState } from 'react';
import SecondaryNavBar from 'Components/SecondaryNavBar/SecondaryNavBar';
import LoadingOverlay from "../../../Components/LoadingOverlay/LoadingOverlay";
import { useSelector } from "react-redux";
import {
    checkEmail, checkTelephone,
    displayJson,
    emptyObject,
    getBooleanValue,
    getNewPeriode,
    renderError,
    upperCaseRemoveAccent
} from "../../../utils/formUtils";
import InfoBulle from "../../../Components/Formulaire/InfoBulle/InfoBulle";
import { checkOverlappingPeriodes, sortPeriodesDescending } from "../../../utils/dateUtils";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { readFileAsBase64 } from "../../../utils/fileUtils";
import { envoiDemandeEditique, envoiFormulaireAcit, envoiPjsAcit } from "../../../api/demandeAcitService";
import { useLocation, useNavigate } from "react-router-dom";
import PaginationWithTable from "../../../Components/PaginationWithTable/PaginationWithTable";
import { getLabelInput, getTypeLabel } from "../../../utils/stringUtils";

import './FormulaireIndemnisation.scss'
import { getInfosCorrespondant } from "../../../api/correspondantsService";

export default function FormulaireIndemnisation() {

    const navigate = useNavigate();
    const location = useLocation();
    const { isSuite, isComplement, dossier } = location.state || {};

    const {
        detailPersonne: detailPersonneComplet,
        contrat,
        demandeAcit,
        contratsBeneficiaires,
        infosComplementaires,
        keycloakReduce,
        infosCorrespondant,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    const contratMp = contratsBeneficiaires?.find(({ typeIndividu }) => typeIndividu === "MP")

    /**
     * TODO
     * contrôle input
     * contrôle submit
     *
     *
     * pas de saisi avant 2 ans en arrière ou date adhésion
     * ajouté infos résiliés
     */

    const CONF = window?.confPub;
    const ROUTES = CONF?.ROUTES
    const PATTERNS = CONF?.PATTERNS
    const UI_ACIT = CONF?.UI?.ACIT
    const TYPE_INDIVIDU = CONF?.TYPE_INDIVIDU
    const FORMULAIRE_ACIT = UI_ACIT?.FORMULAIRE
    const REFERENCES_ACIT = UI_ACIT?.REFERENCES
    // TODO ajouter ça
    const REFERENCES_DOCS_UPLOAD = REFERENCES_ACIT?.UPLOAD_DOCUMENT
    const TYPE_INDEMNITE = REFERENCES_ACIT?.TYPE_INDEMNITE
    const FAMILLE_MAINTIEN_SALAIRE = "MS"
    const FAMILLE_PREF_ACTIFS = "ID"

    const [disabledForm, setDisabledForm] = useState(false)
    const [submitted, setSubmitted] = useState(false)
    const [invalidDossier, setInvalidDossier] = useState(true)
    const [ErrorFormulaire, setErrorFormulaire] = useState(false)

    const dateArretTravailInitial = dossier?.formulaire?.beneficiaire?.contrats.find(({ dateArretTravailInitial }) => dateArretTravailInitial)?.dateArretTravailInitial
    const detailPersonne = demandeAcit?.typeIndividu === TYPE_INDIVIDU?.MP?.CODE ? detailPersonneComplet : demandeAcit

    const isOneEtablissement = infosCorrespondant?.etablissements?.length === 1

    const [formulaireIndemnisation, setFormulaireIndemnisation] = useState({

        [FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]: {
            name: FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME,
            value: isOneEtablissement ? infosCorrespondant?.etablissements?.[0]?.raisonSociale : "",
            invalid: isOneEtablissement ? false : FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.ERRORS?.MANDATORY,
            ...( isOneEtablissement && {  complet: infosCorrespondant?.etablissements?.[0] })
        },
        [FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME]: {
            name: FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME,
            value: false,
            invalid: false,
        },
        [FORMULAIRE_ACIT?.TELEPHONE?.NAME]: {
            name: FORMULAIRE_ACIT?.TELEPHONE?.NAME,
            value: "",
            invalid: false,
        },
        [FORMULAIRE_ACIT?.EMAIL?.NAME]: {
            name: FORMULAIRE_ACIT?.EMAIL?.NAME,
            value: "",
            invalid: false,
        },
        [FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME]: {
            name: FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME,
            value: (isComplement || isSuite) ? dossier?.formulaire?.natureMaladie : '',
            invalid: (isComplement || isSuite) ? false : "Champ obligatoire",
        },
        [FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME]: {
            name: FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME,
            value: !!getBooleanValue(dossier?.formulaire?.[FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME]),
            invalid: false,
        },
        [FORMULAIRE_ACIT?.PARTICIPATION_EMPLOYEUR?.NAME]: {
            name: FORMULAIRE_ACIT?.PARTICIPATION_EMPLOYEUR?.NAME,
            value: !!getBooleanValue(dossier?.formulaire?.[FORMULAIRE_ACIT?.PARTICIPATION_EMPLOYEUR?.NAME]),
            invalid: false,
        },
        [FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE?.NAME]: {
            name: FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE?.NAME,
            value: !!getBooleanValue(dossier?.formulaire?.[FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE?.NAME]),
            invalid: false,
        },
        [FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]: {
            name: FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME,
            value: (isComplement || isSuite) ? moment(dateArretTravailInitial, PATTERNS?.DD_SLASH_MM_SLASH_YYYY).format(PATTERNS?.YYYY_DASH_MM_DASH_DD) : "",
            invalid: (isComplement || isSuite) ? false : "Champ obligatoire",
        },
    })

    const [invalidPj, setInvalidPj] = useState(isComplement ? "Il faut ajouter au moins une pièce jointe" : "Il faut ajouter au moins un bulletin de salaire")

    const [selectedFiles, setSelectedFiles] = useState((isComplement || isSuite) ? dossier?.formulaire?.piecesJointes : []);

    const [showEnvoiModal, setShowEnvoiModal] = useState(false)
    const [modaleEnvoiFichier, setModaleEnvoiFichier] = useState({
        label: "Demande d'indémnisation étape : ",
        etape: 1,

        appel1: {
            label: "En attente ...",
            error: false,
        },
        appel2: {
            label: "En attente ...",
            nombrePj: 1,
            pjEnvoye: 0,
            error: 0,
        },
        appel3: {
            label: "En attente ...",
            error: false,
        },
    })

    const [periodesContrats, setPeriodesContrats] = useState(() => {

        const contratsSuiteComp = dossier?.formulaire?.beneficiaire?.contrats
        return detailPersonne?.contrat?.reduce((acc, element) => {

            const contratSuiteComp = contratsSuiteComp?.find(({ numero }) => numero === element?.numeroContrat)
            const dateArretTravailInitial = moment(contratSuiteComp?.dateArretTravailInitial, PATTERNS?.DD_SLASH_MM_SLASH_YYYY)
            const initialValue = dateArretTravailInitial?.isValid() ? dateArretTravailInitial.format(PATTERNS?.YYYY_DASH_MM_DASH_DD) : ''

            acc[element?.numeroContrat] = {
                numeroContrat: element?.numeroContrat,
                codeFamille: element?.produit,
                familleProduit: element?.nomProduit,
                type: element?.produit === FAMILLE_MAINTIEN_SALAIRE ? TYPE_INDEMNITE?.MAINTIEN_SALAIRE
                    : element?.produit === FAMILLE_PREF_ACTIFS
                        ? TYPE_INDEMNITE?.INDEMNITES_TEMPORAIRES
                        : TYPE_INDEMNITE?.ALLOCATIONS_COMPLEMENTAIRES,
                isIncompletePeriode: false,
                isOverlapping: false,
                periodes: [
                    getNewPeriode()
                ]
            };
            return acc;
        }, {});
    });

    const [periodesCgos, setPeriodeCgos] = useState([
        getNewPeriode()
    ])

    const [isOverlappingCgos, setIsOverlappingCgos] = useState(false)

    useEffect(() => {
        setModaleEnvoiFichier((prev) => ({
            ...prev,
            appel2: {
                ...prev?.appel2,
                nombrePj: selectedFiles?.length > 0 ? selectedFiles.filter(({ nouveau }) => nouveau === true).length : 0
            }
        }))

    }, [selectedFiles])

    const handleInput = (e) => {

        const { name, value, type, checked } = e?.target
        let invalid = false

        switch (name) {

        case FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME:

            if (!value) {
                invalid = "La nature de maladie est obligatoire"
            }
            break

        case FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME:

            if (!value) {
                invalid = "La date d'arrêt de travail intial est obligatoire"
            } else {

                const dateArretInitialMoment = moment(value, PATTERNS?.YYYY_DASH_MM_DASH_DD)

                if (!dateArretInitialMoment?.isValid()) {
                    invalid = "La date n'est pas valide."
                } else {

                    detailPersonne?.contrat.forEach((contrat) => {

                        const dateAdhesionContratMoment = moment(contrat?.dateAdhesionContrat, PATTERNS?.DD_SLASH_MM_SLASH_YYYY)

                        if (dateArretInitialMoment.isBefore(dateAdhesionContratMoment)) {
                            invalid = "La date d'arrêt initial ne peut pas se situer avant votre souscription au contrat."
                        }
                    })
                }
            }
            break

            case FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME:

                invalid = !value ? FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.ERRORS?.MANDATORY : false
                break

            case FORMULAIRE_ACIT?.TELEPHONE?.NAME:

                invalid = (value && !checkTelephone(value)) ? FORMULAIRE_ACIT?.TELEPHONE?.ERRORS?.INVALID : false
                break

            case FORMULAIRE_ACIT?.EMAIL?.NAME:

                invalid = (value && !checkEmail(value)) ? FORMULAIRE_ACIT?.EMAIL?.ERRORS?.INVALID : false
                break
        }

        const newFormulaire = {
            ...formulaireIndemnisation,
            [name]: {
                ...formulaireIndemnisation?.[name],
                value: type === "checkbox" ? checked : value,
                invalid: invalid,
                ...(name === FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME
                    && { complet: infosCorrespondant?.etablissements?.find(({ raisonSociale }) => raisonSociale === value) }
                )
            }
        }

        setInvalidDossier(!checkAnUpdateDossier(newFormulaire, selectedFiles))

        setErrorFormulaire(getErrorFormulaire(newFormulaire, selectedFiles))
    }

    const checkInvalidDate = (date, format) => {

        let invalid = false

        if (!date) {
            invalid = "Date obligatoire"
        } else {

            const dateMoment = moment(date, format)

            invalid = !dateMoment.isValid() ? "Format de date invalide" : false
        }

        return invalid
    }

    const checkIncompletePeriode = (periode) => {

        let isIncompletePeriode = false
        let isInvalidDate = false

        if ((periode?.dateIndemnisationDebut?.value && !periode?.dateIndemnisationFin?.value)
            || !periode?.dateIndemnisationDebut?.value && periode?.dateIndemnisationFin?.value) {

            isIncompletePeriode = true
        } else if (periode?.dateIndemnisationDebut?.value && periode?.dateIndemnisationFin?.value) {

            isInvalidDate = checkInvalidDate(periode?.dateIndemnisationDebut?.value) || checkInvalidDate(periode?.dateIndemnisationDebut?.value)
        }

        return { isIncompletePeriode, isInvalidDate }
    }

    /**
     * Fonction pour vérifier si une période entamée est complète
     * @param periodes
     * @returns {boolean}
     */
    const checkIncompletePeriodes = (periodes) => {

        let isIncompletePeriode = false
        let isInvalidDate = false

        periodes?.length > 0 && periodes.forEach(periode => {

            const { isIncompletePeriode: isIncompletePeriodeFromCheck, isInvalidDate: isInvalidDateFromCheck } = checkIncompletePeriode(periode)

            isIncompletePeriode = isIncompletePeriodeFromCheck ?? isIncompletePeriode
            isInvalidDate = isInvalidDateFromCheck ?? isInvalidDate

        })

        return { isIncompletePeriode, isInvalidDate }
    }

    const handlePeriode = (e, index, numContrat) => {

        const { name, value } = e?.target

        const newPeriodes = numContrat ? periodesContrats?.[numContrat]?.periodes : periodesCgos

        newPeriodes[index] = {
            ...newPeriodes?.[index],
            [name]: {
                ...newPeriodes?.[index]?.[name],
                value: value,
                invalid: checkInvalidDate(value, PATTERNS?.YYYY_DASH_MM_DASH_DD),
            }
        }

        const previousPeriodes = numContrat
            ? dossier?.formulaire?.beneficiaire?.contrats.find(({ numero }) => numero === numContrat)?.periodes
            : dossier?.formulaire?.periodesCgos

        const isOverlapping = checkOverlappingPeriodes(newPeriodes, previousPeriodes)

        // const isIncompletePeriode = checkIncompletePeriodes(newPeriodes)
        const { isIncompletePeriode, isInvalidDate } = checkIncompletePeriodes(newPeriodes)

        if (numContrat) {
            const newContratsFormulaire = {
                ...periodesContrats,
                [numContrat]: {
                    ...periodesContrats?.[numContrat],
                    periodes: newPeriodes,
                    isOverlapping: isOverlapping,
                    isIncompletePeriode: isIncompletePeriode,
                }
            }

            setPeriodesContrats(newContratsFormulaire)

            setInvalidDossier(!checkAnUpdateDossier(formulaireIndemnisation, selectedFiles))
            setErrorFormulaire(getErrorFormulaire(formulaireIndemnisation, selectedFiles))
        } else {

            setIsOverlappingCgos(isOverlapping)
            setPeriodeCgos(newPeriodes)

            setInvalidDossier(!checkAnUpdateDossier(formulaireIndemnisation, selectedFiles))
            setErrorFormulaire(getErrorFormulaire(formulaireIndemnisation, selectedFiles))
        }

        // setInvalidDossier(!checkAnUpdateDossier(formulaireIndemnisation, selectedFiles, periodesContrats, periodesCgos))
    }

    const addPeriode = (numContrat) => {

        const newPeriodes = numContrat ? periodesContrats?.[numContrat]?.periodes : periodesCgos

        newPeriodes.push(getNewPeriode())

        if (numContrat) {

            const newContratsFormulaire = {
                ...periodesContrats,
                [numContrat]: {
                    ...periodesContrats?.[numContrat],
                    periodes: newPeriodes
                }
            }

            setPeriodesContrats(newContratsFormulaire)
        } else {

            setPeriodeCgos(newPeriodes)
        }
    }

    const deletePeriode = (indexIn, numContrat) => {

        const periodesSelected = numContrat ? periodesContrats?.[numContrat]?.periodes : periodesCgos
        const newPeriodes = periodesSelected.filter((_, index) => index !== indexIn);

        const previousPeriodes = numContrat
            ? dossier?.formulaire?.beneficiaire?.contrats.find(({ numero }) => numero === numContrat)?.periodes
            : dossier?.formulaire?.periodesCgos

        const isOverlapping = checkOverlappingPeriodes(newPeriodes, previousPeriodes)
        const { isIncompletePeriode, isInvalidDate } = checkIncompletePeriodes(newPeriodes)

        if (numContrat) {
            const newContratsFormulaire = {
                ...periodesContrats,
                [numContrat]: {
                    ...periodesContrats?.[numContrat],
                    periodes: newPeriodes,
                    isOverlapping: isOverlapping,
                    isIncompletePeriode: isIncompletePeriode,
                }
            }

            setPeriodesContrats(newContratsFormulaire)

        } else {

            setPeriodeCgos(newPeriodes)
        }
    }

    const handleFileChange = async (e) => {

        const id = e?.target?.id
        const files = Array.from(e.target.files)

        // TODO reprendre ce qu'il y a dans le form ?
        const refDocument = REFERENCES_ACIT?.UPLOAD_DOCUMENT?.[id]

        const filesWithBase64 = await Promise.all(
            files.map(async (file) => {
                const base64 = await readFileAsBase64(file)
                return {
                    base64Content: base64,
                    type: refDocument?.TYPE_DOCUMENT,
                    nomFichier: file.name,
                    taille: file?.size,
                    nouveau: true,
                }
            })
        )

        const newSelectedFiles = [
            ...filesWithBase64,
            ...selectedFiles,
        ]

        const newFiles = newSelectedFiles.some(({nouveau}) => nouveau)
        setInvalidPj(newFiles ? false : "Au moins un fichier")

        setSelectedFiles(newSelectedFiles)

        setInvalidDossier(!checkAnUpdateDossier(formulaireIndemnisation, newSelectedFiles))
        setErrorFormulaire(getErrorFormulaire(formulaireIndemnisation, newSelectedFiles))
    }

    const deleteDocument = (indexIn, file) => {

        const newSelecedFiles = selectedFiles.filter((_, index) => index !== indexIn)

        setSelectedFiles(newSelecedFiles)
    }

    const checkForNewValidContratsPeriode = (periodesContrats) => {

        let isContratWithValidPeriode = false

        for (let contratId in periodesContrats) {

            const contrat = periodesContrats[contratId];

            const periodesToCheck = contrat?.periodes

            const newContratPeriode = periodesToCheck?.find(({ dateIndemnisationDebut, dateIndemnisationFin }) =>{

                return (!dateIndemnisationDebut?.invalid && !dateIndemnisationFin?.invalid)
            })

            const { isIncompletePeriode, isInvalidDate } = checkIncompletePeriodes(periodesToCheck)

            isContratWithValidPeriode = !isContratWithValidPeriode ? !emptyObject(newContratPeriode) && !isIncompletePeriode && !isInvalidDate : isContratWithValidPeriode

        }

        return isContratWithValidPeriode
    }

    const checkAnUpdateDossier = (formulaireIn, selectedFilesIn, deconstruct = false) => {

        const isEtablissementCorrespondant = formulaireIn?.[FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]?.value

        // TODO changer ça 1/ vérifier dans tous les cas si établissement CL choisi + mettre à jour le state pour l'établissement pour isComplement
        if (isComplement) {

            setFormulaireIndemnisation(formulaireIn)
            return selectedFilesIn.filter(({ nouveau }) => nouveau).length > 0 && isEtablissementCorrespondant

        } else {

            const isNatureMaladie = formulaireIn?.[FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME]?.value !== ""
                && formulaireIn?.[FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME]?.invalid === false

            const isNewBulletinSalaire = selectedFilesIn.some(({ nouveau, type }) => nouveau && type === REFERENCES_ACIT?.UPLOAD_DOCUMENT?.bulletinSalaire?.TYPE_DOCUMENT)

            const isValidDateArretTravailInitial = formulaireIn?.[FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]?.value !== ""
                && formulaireIn?.[FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]?.invalid === false

            let isContratWithValidPeriode = checkForNewValidContratsPeriode(periodesContrats)

            let isJustificatifIjSecuSoc = true
            let isValidCgos = true
            let isValidNewCoordonnees = true

            let newFormulaire = {
                ...formulaireIn
            }

            if (formulaireIn?.[FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE?.NAME]?.value) {

                isJustificatifIjSecuSoc = selectedFilesIn.some(({ type}) => type === REFERENCES_ACIT?.UPLOAD_DOCUMENT?.justificatifIjSecuSoc?.TYPE_DOCUMENT)

                newFormulaire = {
                    ...newFormulaire,
                    [FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE?.NAME]: {
                        ...formulaireIn?.[FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE?.NAME],
                        invalid: !isJustificatifIjSecuSoc ? "Vous devez fournir un justificatif de la sécurité social" : false
                    }
                }
            }

            if (formulaireIn?.[FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME]?.value) {

                // TODO vérification périodes CGOS valides
                const isJustificatifCgos = selectedFilesIn.some(({ type}) => type === REFERENCES_ACIT?.UPLOAD_DOCUMENT?.justificatifCgos?.TYPE_DOCUMENT)

                const isValidOldCgosPeriode = dossier?.formulaire?.periodesCgos?.length > 0
                const isValidNewCgosPeriode = periodesCgos?.some(periode => {

                    return !periode?.dateIndemnisationDebut?.invalid && !periode?.dateIndemnisationFin?.invalid
                })

                const { isIncompletePeriode } = checkIncompletePeriodes(periodesCgos)

                isValidCgos = isJustificatifCgos || (isValidOldCgosPeriode || (isValidNewCgosPeriode && !isIncompletePeriode))

                newFormulaire = {
                    ...newFormulaire,
                    [FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME]: {
                        ...formulaireIn?.[FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME],
                        invalid: !isValidCgos ? "Vous devez fournir un justificatif CGOS ou renseigner au moins période d'indémnisation" : false
                    }
                }
            }

            if (getBooleanValue(formulaireIn?.[FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME]?.value)) {

                isValidNewCoordonnees = (formulaireIn?.[FORMULAIRE_ACIT?.TELEPHONE?.NAME]?.value && !formulaireIn?.[FORMULAIRE_ACIT?.TELEPHONE?.NAME]?.invalid)
                    || (formulaireIn?.[FORMULAIRE_ACIT?.EMAIL?.NAME]?.value && !formulaireIn?.[FORMULAIRE_ACIT?.EMAIL?.NAME]?.invalid)

                newFormulaire = {
                    ...newFormulaire,
                    [FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME]: {
                        ...formulaireIn?.[FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME],
                        invalid: !isValidNewCoordonnees ? "Vous devez renseigner au moins un nouvel email ou un téléphone" : false
                    }
                }
            }

            setFormulaireIndemnisation(newFormulaire)

            if (!deconstruct) {
                return isNatureMaladie
                    && isNewBulletinSalaire
                    && isValidDateArretTravailInitial
                    && isContratWithValidPeriode
                    && isJustificatifIjSecuSoc
                    && isValidCgos
                    && isValidNewCoordonnees
                    && isEtablissementCorrespondant
            }

            return {
                isNatureMaladie,
                isNewBulletinSalaire,
                isValidDateArretTravailInitial,
                isContratWithValidPeriode,
                isJustificatifIjSecuSoc,
                isValidCgos,
                isValidNewCoordonnees,
                isEtablissementCorrespondant
            }
        }
    }

    const handleSubmit = async (e) => {

        e.preventDefault()
        setSubmitted(true)

        // ###################### Envoi formulaire
        // TODO conditions générales
        /**
         * suite ou ouverture une période + une fiche de paye
         * comp une pj n'importe laquelle
         */

        // TODO travailler les conditions
        /**
         * Si ouverture : nature maladie, date début arrêt, au moins une période et un bulletin de salaire
         * Si complément : au moins un nouveau document
         * Si suite : au moins une nouvelle période et un nouveau bulletin de salaire
         *
         * En ouverture et suite seulement :
         * Si participation SS : justificatif d'IJ SS (nouveau ou ancien si saisi précédemment)
         * Si CGOS : justificatif CGOS (nouveau ou ancien si saisi précédemment) et au moins une période
         */

        setErrorFormulaire(getErrorFormulaire(formulaireIndemnisation, selectedFiles))

        // TODO ajouter les condition CGOS et IJS
        if (checkAnUpdateDossier(formulaireIndemnisation, selectedFiles)) {

            setInvalidDossier(false)
            setShowEnvoiModal(true)

            const formulaireDemande = buildDemande(detailPersonne, formulaireIndemnisation, periodesContrats, infosComplementaires)

            console.log("formulaireDemande")
            console.log(formulaireDemande)

            try {

                const envoiFormulaireAcitResult = await envoiFormulaireAcit(formulaireDemande)

                displayEtapeEnvoi("PASSAGE_ETAPE_2")

                console.log("###############################")
                console.log("envoiFormulaireAcitResult")
                console.log(envoiFormulaireAcitResult)

                const uuidDemande = envoiFormulaireAcitResult?.demandesACITType?.[0]?.uuid

                // ###################### Envoi Pièces jointes
                if (uuidDemande) {
                    for (const fileData of selectedFiles) {

                        if (fileData?.nouveau) {
                            try {

                                const pieceJointe = {
                                    name: fileData.nomFichier,
                                    // type: UI_ACIT?.FORMULAIRE?.FORM_FILE?.OPTIONS.find(doc => doc?.CODE_DOCUMENT === fileData?.categorie)?.TYPE_DOCUMENT || fileData?.categorie,
                                    type: fileData?.type,
                                    base64Content: fileData.base64Content,
                                }

                                const envoiPjResult = await envoiPjsAcit(uuidDemande, pieceJointe)

                                console.log("envoi de pièce jointe")
                                console.log(envoiPjResult)

                                displayEtapeEnvoi("ETAPE_2_ENVOI_PJ", true)

                            } catch (err) {
                                console.log("Erreur lors de l'envoi de pièce jointe :", err)
                                displayEtapeEnvoi("ETAPE_2_ENVOI_PJ", false)
                            }
                        }
                    }

                    // ###################### Envoi demande
                    displayEtapeEnvoi("PASSAGE_ETAPE_3")

                    if (detailPersonne?.idUniqueGrc) {
                        try {

                            const envoiDemandeEditiqueResult = await envoiDemandeEditique(uuidDemande, detailPersonne?.idUniqueGrc)

                            console.log("envoiDemandeEditiqueResult")
                            console.log(envoiDemandeEditiqueResult)

                            displayEtapeEnvoi("ETAPE_3_ENVOI", true)

                        } catch (err) {
                            console.log("Erreur lors de l'envoi de pièce jointe :", err)

                            displayEtapeEnvoi("ETAPE_3_ENVOI", false)
                        }
                    } else {
                        console.log("Impossible d'envoyer demande éditique pas d'idGrcUnique")
                    }

                } else {
                    console.log("Echec de la demande")
                    // TODO mettre message d'erreur
                    // Erreur formulaire
                }
            } catch (err) {

                console.log("err", err)
                displayEtapeEnvoi("ETAPE_1_ECHEC")
            }
        } else {

            setInvalidDossier(true)
        }
    }

    const buildDemande = (detailPersonne, formulaireIndemnisation, contratsFormulaire, infosComplementaires) => {

        const { typeDemande, contratList } = buildContratsPart(detailPersonne, contratsFormulaire, formulaireIndemnisation)

        const infosEtablissement = formulaireIndemnisation?.[FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]?.complet

        const isNewCoordonnees = getBooleanValue(formulaireIndemnisation?.[FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME]?.value)

        // Permet de récupérer une adresse (obligatoire) si non présente sur les CJT et les ENF
        const adresseBeneficiaire = detailPersonne?.codePostal?.trim() && detailPersonne?.ville?.trim() ? detailPersonne : contratMp

        const adresseLigne2 = adresseBeneficiaire?.adrL3 && adresseBeneficiaire?.adrL4
            ? `${ adresseBeneficiaire?.adrL3 } ${ adresseBeneficiaire?.adrL4 }`
            : adresseBeneficiaire?.adVoie

        const telephone = (isNewCoordonnees
            && formulaireIndemnisation?.[FORMULAIRE_ACIT?.TELEPHONE?.NAME]?.value
            && !formulaireIndemnisation?.[FORMULAIRE_ACIT?.TELEPHONE?.NAME]?.invalid)
            ? formulaireIndemnisation?.[FORMULAIRE_ACIT?.TELEPHONE?.NAME]?.value
            : infosEtablissement?.numTel

        const email = (isNewCoordonnees
            && formulaireIndemnisation?.[FORMULAIRE_ACIT?.EMAIL?.NAME]?.value
            && !formulaireIndemnisation?.[FORMULAIRE_ACIT?.EMAIL?.NAME]?.invalid)
            ? formulaireIndemnisation?.[FORMULAIRE_ACIT?.EMAIL?.NAME]?.value
            : infosEtablissement?.courriel

        // TODO faire évoluer le back pour pouvoir mettre le bon type
        return {
            name: `Demande AC/IT: ${ detailPersonne?.civilite } ${ detailPersonne?.prenom } ${ detailPersonne?.nom }`,
            type: typeDemande === "ms" ? 'it' : typeDemande,
            jsonStringFormulaire: {

                // todo rajouter maj tel et courriel
                correspondant: {
                    idGrm: infosCorrespondant?.numPersCorr,
                    nom: infosCorrespondant?.nom,
                    prenom: infosCorrespondant?.prenom,
                    civilite: infosCorrespondant?.civilite,
                    telephone: telephone,
                    adresseMail: email,
                    etablissement: [
                        {
                            numeroFiness: infosEtablissement?.finess,
                            raisonSociale: infosEtablissement?.raisonSociale,
                            codeEtablissement: infosEtablissement?.codeEtab,
                            codePostal: infosEtablissement?.codePostal,
                            adresse: infosEtablissement?.ligAdresse1,
                            dateDebFonct: infosEtablissement?.dateDebFonct,
                            // "dateFinFonct": "",
                            telephone: telephone,
                            courriel: email,
                            "actif": true
                        }
                    ],
                },
                nomAdresseEtablissement: `${ infosEtablissement?.raisonSociale } ${ infosEtablissement?.ligAdresse1 } ${ infosEtablissement?.codePostal } ${ infosEtablissement?.ville }`,

                pjnew: selectedFiles?.length > 0 ? selectedFiles.filter(({ nouveau }) => nouveau === true).length : 0,
                nom: `Demande AC/IT: ${ detailPersonne?.civilite } ${ detailPersonne?.prenom } ${ detailPersonne?.nom }`,
                ouverture: isSuite ? REFERENCES_ACIT?.STATUT_DOSSIER?.SUITE?.VALUE : isComplement
                    ? REFERENCES_ACIT?.STATUT_DOSSIER?.COMPLEMENT?.VALUE : REFERENCES_ACIT?.STATUT_DOSSIER?.OUVERTURE?.VALUE,
                ...(getBooleanValue((isComplement || isSuite) && dossier?.uuid !== null) && {
                    demandeUuid: dossier?.uuid,
                }),
                type: typeDemande === "ms" ? 'it' : typeDemande,
                natureMaladie: formulaireIndemnisation?.[FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME]?.value,
                indemniseParCGOS: formulaireIndemnisation?.[FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME]?.value ? "oui" : "non",
                participEmployeur: formulaireIndemnisation?.[FORMULAIRE_ACIT?.PARTICIPATION_EMPLOYEUR?.NAME]?.value ? "oui" : "non",
                participSecuSoc: formulaireIndemnisation?.[FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE?.NAME]?.value ? "oui" : "non",

                ...(formulaireIndemnisation?.[FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME]?.value && {
                    periodesCgos: buildPeriodes(periodesCgos, dossier?.formulaire?.periodesCgos),
                }),

                beneficiaire: {
                    idGrc: detailPersonne?.idPersGrc,
                    numUniqueGrc: detailPersonne?.idUniqueGrc,
                    adresse1: `${ detailPersonne?.civilite } ${ detailPersonne?.prenom } ${ detailPersonne?.nom }`,
                    adresse2: adresseLigne2,
                    codePostal: adresseBeneficiaire?.codePostal,
                    ville: adresseBeneficiaire?.ville,
                    telPortable: detailPersonne?.telPrincipal,
                    email: detailPersonne?.email,
                    nir: infosComplementaires?.persNir,
                    nom: detailPersonne?.nom,
                    prenom: detailPersonne?.prenom,
                    dateNaissance: detailPersonne?.dateNaissance,
                    civilite: detailPersonne?.civilite,
                    contrats: contratList,
                },

                piecesJointes: buildPjsPart(selectedFiles),
            }
        }
    }

    const buildContratsPart = (detailPersonne, contratsFormulaire) => {

        const contratList = []
        const typeDemandeListe = []

        console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
        console.log("##################################")
        console.log("formulaireIndemnisation")
        console.log(formulaireIndemnisation)

        for (let contratId in contratsFormulaire) {

            const contrat = contratsFormulaire[contratId];

            const contratRef = detailPersonne?.contrat?.find(({ numeroContrat }) => numeroContrat === contratId)

            if (formulaireIndemnisation?.[FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]?.value) {

                const periodesFromDossier = (isSuite || isComplement) ? dossier?.formulaire?.beneficiaire?.contrats.find(({ numero }) => numero === contratId)?.periodes : []

                const periodesSend = buildPeriodes(contrat?.periodes, periodesFromDossier)

                if (periodesSend?.length > 0) {

                    const contratToSend = {
                        numero: contrat?.numeroContrat,
                        codeFamille: contrat?.codeFamille,
                        codeProduit: contratRef?.codeProduit,
                        dateAdhesionContrat: contratRef?.dateAdhesionContrat,
                        dateRadiationContrat: contratRef?.dateRadiationContrat,
                        type: contrat?.type,
                        familleProduit: contratRef?.familleProduit,
                        "statut": "Valide",
                        "version": "1",
                        "dateDebutValidite": "21/10/2023",
                        "dateFinValidite": "15/10/2029",
                        dateArretTravailInitial: moment(formulaireIndemnisation?.[FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]?.value, PATTERNS?.YYYY_DASH_MM_DASH_DD).format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY),
                        periodes: periodesSend
                    }

                    typeDemandeListe.push(contrat?.type)
                    contratList.push(contratToSend)
                }
            }
        }

        let typeDemande = ''

        if (typeDemandeListe.includes(TYPE_INDEMNITE?.ALLOCATIONS_COMPLEMENTAIRES)
            && typeDemandeListe.includes(TYPE_INDEMNITE?.INDEMNITES_TEMPORAIRES)) {

            typeDemande = TYPE_INDEMNITE?.ALLOCATIONS_COMPLEMENTAIRES_INDEMNITES_TEMPORAIRES

        } else if (typeDemandeListe.includes(TYPE_INDEMNITE?.ALLOCATIONS_COMPLEMENTAIRES)) {

            typeDemande = TYPE_INDEMNITE?.ALLOCATIONS_COMPLEMENTAIRES

        } else if (typeDemandeListe.includes(TYPE_INDEMNITE?.INDEMNITES_TEMPORAIRES)) {

            typeDemande = TYPE_INDEMNITE?.INDEMNITES_TEMPORAIRES

        } else if (typeDemandeListe.includes(TYPE_INDEMNITE?.MAINTIEN_SALAIRE)) {

            typeDemande = TYPE_INDEMNITE?.MAINTIEN_SALAIRE
        }

        return { typeDemande, contratList }
    }

    const buildPjsPart = (selectedFiles) => {

        return selectedFiles?.map(file => {
            return {
                type: file?.type,
                nomFichier: file?.nomFichier,
                taille: file?.taille,
                nouveau: file?.nouveau ?? false,
            }
        })
    }

    const buildPeriodes = (periodesForm, perdiodesFromDossier) => {

        const newPeriodes = periodesForm.filter(periode => periode?.dateIndemnisationDebut?.value && periode?.dateIndemnisationFin?.value).map(periode => {

            return {
                nouveau: periode?.nouveau,
                dateIndemnisationDebut: moment(periode?.dateIndemnisationDebut?.value, PATTERNS?.YYYY_DASH_MM_DASH_DD).format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY),
                dateIndemnisationFin: moment(periode?.dateIndemnisationFin?.value, PATTERNS?.YYYY_DASH_MM_DASH_DD).format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY),
            }
        })

        if ((isSuite || isComplement) && perdiodesFromDossier?.length > 0) {
            perdiodesFromDossier?.forEach(periode => {
                newPeriodes.push({
                    ...periode,
                    nouveau: 'N'
                })
            })
        }

        return newPeriodes
    }

    const BuildPeriodesTable = ({ data: periodes }) => {

        return (<div className='table-responsive-lg mt-2'>
            <table className="table">
                <thead>
                <tr>
                    <th className="text-center">Date début :</th>
                    <th className="text-center">Date fin :</th>
                </tr>
                </thead>
                <tbody>
                { periodes?.length > 0 && periodes?.map((periode, index) => (
                    <tr key={ `${ index }` }>
                        <td className="text-center">
                            { periode?.dateIndemnisationDebut }
                        </td>
                        <td className="text-center">
                            { periode?.dateIndemnisationFin }
                        </td>
                    </tr>
                )) }
                </tbody>
            </table>
        </div>)
    }

    const DocumentsTable = ({ data: selectedFiles }) => {

        if (selectedFiles?.length > 0) {
            return (

                <div className='table-responsive-lg mt-2'>
                    <table className="table">
                        <thead>
                        <tr>
                            <th className="text-center">Nom du document</th>
                            <th className="text-center">Catégorie</th>
                            <th className="text-center">Taille</th>
                            <th className="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        { selectedFiles?.length > 0 && selectedFiles.map((file, index) => {

                            return (
                                <tr key={ `doc-${ index }` }>
                                    <td className="text-center">
                                        { file?.nomFichier }
                                    </td>
                                    <td className="text-center">
                                        { UI_ACIT?.FORMULAIRE?.FORM_FILE?.OPTIONS.find(doc => doc?.TYPE_DOCUMENT === file?.type)?.LABEL || file?.type }
                                    </td>
                                    <td className="text-center">
                                        { file?.taille }
                                    </td>
                                    <td className="text-center">
                                        { file?.nouveau ? (
                                            <button
                                                className="btn btn-sm btn-secondary"
                                                type='button'
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    deleteDocument(index, file)
                                                }}>
                                                Retirer
                                            </button>
                                        ) : (
                                            <span>Envoyé précédemment</span>
                                        ) }

                                    </td>
                                </tr>
                            )
                        }) }
                        </tbody>
                    </table>
                </div>
            )
        } else {

            return (
                <div>
                    Aucun document ajouté
                </div>
            )
        }
    }

    const getErrorFormulaire = (formulaireIndemnisation, selectedFiles) => {

        const {
            isNatureMaladie,
            isNewBulletinSalaire,
            isValidDateArretTravailInitial,
            isContratWithValidPeriode,
            isJustificatifIjSecuSoc,
            isValidCgos,
            isValidNewCoordonnees,
            isEtablissementCorrespondant
        } = checkAnUpdateDossier(formulaireIndemnisation, selectedFiles, true)

        let errorMessage = "Vous devez avoir renseigné :"

        if (isComplement) {

            errorMessage += " une nouvelle pièce jointe"

        } else if (isSuite) {

            let previousParam = false

            if (!isContratWithValidPeriode) {
                errorMessage += " une nouvelle période"
                previousParam = true
            }

            if (!isNewBulletinSalaire) {
                if (previousParam) {
                    errorMessage += ",";
                }
                errorMessage += " un nouveau bulletin de salaire"
                previousParam = true
            }

            if (!isValidCgos) {
                if (previousParam) {
                    errorMessage += ",";
                }
                errorMessage += " les informations CGOS"
                previousParam = true
            }

            if (!isJustificatifIjSecuSoc) {
                if (previousParam) {
                    errorMessage += ",";
                }
                errorMessage += " les informations sécutié social"
                previousParam = true
            }

            if (!isValidNewCoordonnees) {
                if (previousParam) {
                    errorMessage += ",";
                }
                errorMessage += " les nouvelles coordonées"
                previousParam = true
            }
        } else {

            let previousParam = false

            if (!isNatureMaladie) {
                errorMessage += " une nature de maladie"
                previousParam = true
            }

            if (!isEtablissementCorrespondant) {
                if (previousParam) {
                    errorMessage += ","
                }
                errorMessage += " votre établissement"
                previousParam = true
            }

            if (!isValidDateArretTravailInitial) {
                if (previousParam) {
                    errorMessage += ","
                }
                errorMessage += " une date de début d'arrêt de travail"
                previousParam = true
            }

            if (!isContratWithValidPeriode) {
                if (previousParam) {
                    errorMessage += ",";
                }
                errorMessage += " au moins une période d'indémnisation"
                previousParam = true
            }

            if (!isNewBulletinSalaire) {
                if (previousParam) {
                    errorMessage += ",";
                }
                errorMessage += " au moins une fiche de paye"
                previousParam = true
            }

            if (!isValidCgos) {
                if (previousParam) {
                    errorMessage += ",";
                }
                errorMessage += " les informations CGOS"
                previousParam = true
            }

            if (!isJustificatifIjSecuSoc) {
                if (previousParam) {
                    errorMessage += ",";
                }
                errorMessage += " les informations sécutié social"
                previousParam = true
            }

            if (!isValidNewCoordonnees) {
                if (previousParam) {
                    errorMessage += ","
                }
                errorMessage += " les nouvelles coordonées"
                previousParam = true
            }
        }

        errorMessage += "."

        return errorMessage
    }

    const displayEtapeEnvoi = (etape, sucess) => {

        const updateModaleState = (etapeData) => {
            setModaleEnvoiFichier((prev) => ({
                ...prev,
                ...etapeData,
            }))
        };

        switch (etape) {
        case "ETAPE_1_ECHEC":
            updateModaleState({
                appel1: {
                    label: "Envoi terminé",
                    error: "Echec de l'envoi du formulaire",
                }
            })
            break

        case "PASSAGE_ETAPE_2":
            updateModaleState({
                etape: 2,
                appel1: {
                    label: "Envoyé",
                }
            })
            break

        case "ETAPE_2_ENVOI_PJ":
            setModaleEnvoiFichier((prev) => {
                const { pjEnvoye = 0, nombrePj = 0, error = 0 } = prev?.appel2 || {}

                return {
                    ...prev,
                    appel2: {
                        ...prev?.appel2,
                        label: `${pjEnvoye + (sucess ? 1 : 0) > 1
                            ? 'Pièces jointes envoyées' : 'Pièce jointe envoyée'} 
                            : ${pjEnvoye + (sucess ? 1 : 0)}/${nombrePj}`,
                        pjEnvoye: pjEnvoye + (sucess ? 1 : 0),
                        error: error + (!sucess ? 1 : 0),
                    }
                };
            });
            break;

        case "PASSAGE_ETAPE_3":
            updateModaleState({
                etape: 3,

            })
            break

        case "ETAPE_3_ENVOI":
            updateModaleState({
                appel3: {
                    label: "Envoi terminé",
                    error: !sucess ? "Echec de l'envoi de la demande" : false,
                }
            })
            break

        default:
            console.warn("Étape inconnue:", etape)
            break
        }
    }

    return (
        <div className="container demande-indemnisation-container mt-3">

            <SecondaryNavBar activePage='indemnisation-formulaire'/>

            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className={ 'card' }>
                    <form onSubmit={ handleSubmit }>
                        <div className="card-header">
                            <h1 className="my-2">Formulaire
                                d'indémnisation { isComplement ? `- ${ REFERENCES_ACIT?.STATUT_DOSSIER?.COMPLEMENT?.LABEL }`
                                    : isSuite ? `- ${ REFERENCES_ACIT?.STATUT_DOSSIER?.SUITE?.LABEL }`
                                        : `- ${ REFERENCES_ACIT?.STATUT_DOSSIER?.OUVERTURE?.LABEL }` }</h1>
                            <h2>
                                { detailPersonne?.civilite } { detailPersonne?.prenom } { detailPersonne?.nom } - { getTypeLabel(detailPersonne?.typeIndividu) }
                            </h2>
                        </div>

                        <div className="card-body">
                            { demandeAcit?.typeIndividu !== TYPE_INDIVIDU?.MP?.CODE && (
                                <div className="row mb-3">
                                    <div className="col infos-importante">
                                        Lors de l'étude de votre dossier de demande d'indemnisation, le service adhérent pourra demander une justification d'activité en milieu hospitalier
                                    </div>
                                </div>
                            ) }
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>Demande d'indémnisation</h2>

                                    <div className={ "col-lg-6" }>
                                        <label
                                            className='form-label'
                                            htmlFor={ FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME }>
                                            { FORMULAIRE_ACIT?.NATURE_MALADIE?.LABEL }
                                        </label>
                                        <select
                                            className="form-control"
                                            name={ FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME }
                                            id={ FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME }
                                            value={ formulaireIndemnisation?.[FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME]?.value || "" }
                                            disabled={ isComplement }
                                            onChange={ handleInput }
                                        >
                                            <option value="" disabled defaultValue={ 'true' }>Sélectionner</option>
                                            { FORMULAIRE_ACIT?.NATURE_MALADIE?.OPTIONS?.length > 0 && FORMULAIRE_ACIT?.NATURE_MALADIE?.OPTIONS?.map(option => {
                                                return (
                                                    <option key={ option?.VALUE }
                                                            value={ option?.VALUE }>{ option?.LABEL }</option>
                                                )
                                            }) }
                                        </select>

                                        { submitted && formulaireIndemnisation?.[FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME]?.invalid
                                            && renderError(formulaireIndemnisation?.[FORMULAIRE_ACIT?.NATURE_MALADIE?.NAME]?.invalid) }
                                    </div>

                                    <div className="mt-3">
                                        <div className='form-label'>
                                            Cochez la ou les cases en cas de participation :
                                        </div>

                                        { [
                                            FORMULAIRE_ACIT?.PARTICIPATION_EMPLOYEUR,
                                            FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE,
                                            FORMULAIRE_ACIT?.INDEMNITE_CGOS
                                        ].map((item, index) => (
                                            <div key={ item?.NAME }>
                                                <div className="mt-2 ms-3" key={ index }>
                                                    <input
                                                        type="checkbox"
                                                        name={ item?.NAME }
                                                        id={ item?.NAME }
                                                        onChange={ handleInput }
                                                        className="form-check-input"
                                                        checked={ formulaireIndemnisation?.[item?.NAME]?.value || "" }
                                                        disabled={ isComplement }
                                                    />
                                                    <label
                                                        className="form-check-label ms-2"
                                                        htmlFor={ item?.NAME }>
                                                        { item?.LABEL }
                                                    </label>
                                                </div>

                                                { item?.NAME === FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE?.NAME &&
                                                    formulaireIndemnisation?.[FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE?.NAME]?.value && (
                                                        <div className="ms-2 mt-2 col-lg-9">
                                                            <label htmlFor="justificatifIjSecuSoc"
                                                                   className="form-label">
                                                                Téléchargez justificatif d'IJ Sécurité Sociale&nbsp;:
                                                            </label>
                                                            <input
                                                                id="justificatifIjSecuSoc"
                                                                name="formFile"
                                                                className="form-control"
                                                                type="file"
                                                                multiple
                                                                onChange={ handleFileChange }
                                                                disabled={ isComplement }
                                                            />

                                                            { submitted && formulaireIndemnisation?.[FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE?.NAME]?.invalid
                                                                && renderError(formulaireIndemnisation?.[FORMULAIRE_ACIT?.PARTICIPATION_SECURITE_SOCIALE?.NAME]?.invalid) }
                                                        </div>
                                                    ) }

                                                { item?.NAME === FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME
                                                    && formulaireIndemnisation?.[FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME]?.value && (
                                                        <div className="ms-2 mt-2 col-lg-9">
                                                            <label htmlFor="justificatifCgos"
                                                                   className="form-label">
                                                                Téléchargez justificatif CGOS&nbsp;:
                                                            </label>
                                                            <input
                                                                id="justificatifCgos"
                                                                name="formFile"
                                                                className="form-control"
                                                                type="file"
                                                                multiple
                                                                onChange={ handleFileChange }
                                                                disabled={ isComplement }
                                                            />

                                                            <div>
                                                                <div className='form-label mt-3'>
                                                                    Périodes Indemnisées par le CGOS :
                                                                </div>
                                                                { (!isComplement && periodesCgos?.length > 0) && periodesCgos.map((periode, index) => (
                                                                    <div className='row mt-3' key={ `periode-cgos-${ index }` }>
                                                                        <div className="col-lg-5">
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor={ `dateIndemnisationDebut-${ periode?.numeroContrat }-${ index }` }>
                                                                                Date début :
                                                                            </label>
                                                                            <input
                                                                                id={ `dateIndemnisationDebut-${ periode?.numeroContrat }-${ index }` }
                                                                                name={ 'dateIndemnisationDebut' }
                                                                                onChange={ (e) => handlePeriode(e, index) }
                                                                                className='form-control'
                                                                                min={ periodesContrats?.[periode?.numeroContrat]?.dateArretTravailInitial?.value }
                                                                                type="date"/>
                                                                        </div>
                                                                        <div className="col-lg-5">
                                                                            <label
                                                                                className="form-label"
                                                                                htmlFor={ `dateIndemnisationFin-${ periode?.numeroContrat }-${ index }` }>
                                                                                Date fin :
                                                                            </label>
                                                                            <input
                                                                                id={ `dateIndemnisationFin-${ periode?.numeroContrat }-${ index }` }
                                                                                name={ 'dateIndemnisationFin' }
                                                                                onChange={ (e) => handlePeriode(e, index) }
                                                                                className='form-control'
                                                                                min={ periode?.dateIndemnisationDebut?.value ?? periodesContrats?.[periode?.numeroContrat]?.dateArretTravailInitial?.value }
                                                                                type="date"/>
                                                                        </div>

                                                                        <div
                                                                            className="col-lg-2 d-flex align-items-end">
                                                                            { index !== 0 && (
                                                                                <button
                                                                                    onClick={ () => deletePeriode(index) }
                                                                                    type="button"
                                                                                    className="btn btn-secondary px-1">
                                                                                    Supp
                                                                                </button>
                                                                            ) }
                                                                        </div>
                                                                    </div>
                                                                )) }

                                                                { isOverlappingCgos && (
                                                                    renderError("Vous ne pouvez pas avoir de recoupement entre les périodes")
                                                                ) }

                                                                { !isComplement && (
                                                                    <div
                                                                        className="mt-3 d-flex justify-content-end">
                                                                        <button
                                                                            onClick={ () => addPeriode() }
                                                                            type="button"
                                                                            className="btn btn-primary px-1">
                                                                            Ajouter période
                                                                        </button>
                                                                    </div>
                                                                ) }

                                                                { ((isComplement || isSuite) && dossier?.formulaire?.periodesCgos?.length > 0) && (() => {

                                                                    const sortedPeriodes = sortPeriodesDescending(dossier?.formulaire?.periodesCgos)

                                                                    return (
                                                                        <PaginationWithTable
                                                                            records={ sortedPeriodes }
                                                                            recordsPerPage={ 4 }
                                                                            TableComponent={ BuildPeriodesTable }
                                                                        />
                                                                    )
                                                                })()}

                                                                { submitted && formulaireIndemnisation?.[FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME]?.invalid
                                                                    && renderError(formulaireIndemnisation?.[FORMULAIRE_ACIT?.INDEMNITE_CGOS?.NAME]?.invalid) }
                                                            </div>
                                                        </div>
                                                    ) }
                                            </div>
                                        )) }
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <h2>Correspondant</h2>
                                    <div>
                                        <div className="d-flex align-items-baseline">
                                            <div className="form-label me-2">Correspondant :</div>
                                            <div>
                                                { infosCorrespondant?.civilite } { infosCorrespondant?.prenom } { infosCorrespondant?.nom }
                                            </div>
                                        </div>

                                        <div className="form-group col-lg-8">
                                            <label
                                                htmlFor={ FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME }>
                                                { getLabelInput(FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT) }
                                            </label>
                                            <select
                                                className="form-control"
                                                id={ FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME }
                                                name={ FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME }
                                                onChange={ handleInput }
                                                value={ formulaireIndemnisation?.[FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]?.value }
                                            >
                                                <option value="" disabled defaultValue={ '' }>Sélectionner</option>
                                                { infosCorrespondant?.etablissements?.length > 0 && infosCorrespondant?.etablissements?.map(etablissement => (
                                                    <option
                                                        key={ etablissement?.raisonSociale }
                                                        value={ etablissement?.raisonSociale }
                                                    >
                                                        { etablissement?.raisonSociale }
                                                    </option>
                                                )) }
                                            </select>

                                            { submitted && formulaireIndemnisation?.[FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]?.invalid
                                                && renderError(formulaireIndemnisation?.[FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]?.invalid) }
                                        </div>

                                        { formulaireIndemnisation?.[FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]?.value && (
                                            <>

                                                <div className={ 'mt-3' }>
                                                    <div className="d-flex align-items-baseline">
                                                        <div className="form-label me-2">Rue :</div>
                                                        <div>{ formulaireIndemnisation?.[FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]?.complet?.ligAdresse1 }</div>
                                                    </div>
                                                    <div className="d-flex align-items-baseline">
                                                        <div className="form-label me-2">Ville :</div>
                                                        <div>{ formulaireIndemnisation?.[FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]?.complet?.codePostal } { formulaireIndemnisation?.[FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]?.complet?.ville }</div>
                                                    </div>

                                                    <div className="d-flex align-items-baseline">
                                                        <div className="form-label me-2">Courriel établissement :</div>
                                                        <div>{ formulaireIndemnisation?.[FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]?.complet?.courriel }</div>
                                                    </div>
                                                    <div className="d-flex align-items-baseline">
                                                        <div className="form-label me-2">Téléphone établissement :</div>
                                                        <div>{ formulaireIndemnisation?.[FORMULAIRE_ACIT?.ETABLISSEMENT_CORRESPONDANT?.NAME]?.complet?.numTel }</div>
                                                    </div>

                                                </div>
                                                <div className="form-check form-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        name={ FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME }
                                                        id={ FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME }
                                                        onChange={ handleInput }
                                                        checked={ formulaireIndemnisation?.[FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME]?.value || "" }
                                                        disabled={ isComplement } // TODO raison pour laquelle ce bouton est bloqué en complément ?
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={ FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME }
                                                    >
                                                        { FORMULAIRE_ACIT?.NEW_COORDONNEES?.LABEL }
                                                    </label>
                                                </div>

                                                { formulaireIndemnisation?.[FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME]?.value && (
                                                    <>
                                                        <div className="row">
                                                            <div className={ 'mt-2 col-lg-6' }>
                                                                <label
                                                                    htmlFor={ FORMULAIRE_ACIT?.TELEPHONE?.NAME }
                                                                    className='form-label'>
                                                                    { getLabelInput(FORMULAIRE_ACIT?.TELEPHONE) }
                                                                </label>
                                                                <input
                                                                    id={ FORMULAIRE_ACIT?.TELEPHONE?.NAME }
                                                                    name={ FORMULAIRE_ACIT?.TELEPHONE?.NAME }
                                                                    type="text"
                                                                    value={ formulaireIndemnisation?.[FORMULAIRE_ACIT?.TELEPHONE?.NAME]?.value }
                                                                    onChange={ handleInput }
                                                                    className='form-control'
                                                                    placeholder={ FORMULAIRE_ACIT?.TELEPHONE?.PLACEHOLDER }
                                                                />

                                                                { submitted && formulaireIndemnisation?.[FORMULAIRE_ACIT?.TELEPHONE?.NAME]?.invalid
                                                                    && renderError(formulaireIndemnisation?.[FORMULAIRE_ACIT?.TELEPHONE?.NAME]?.invalid) }
                                                            </div>

                                                            <div className={ 'mt-2 col-lg-6' }>
                                                                <label
                                                                    htmlFor={ FORMULAIRE_ACIT?.EMAIL?.NAME }
                                                                    className='form-label'>
                                                                    { getLabelInput(FORMULAIRE_ACIT?.EMAIL) }
                                                                </label>
                                                                <input
                                                                    id={ FORMULAIRE_ACIT?.EMAIL?.NAME }
                                                                    name={ FORMULAIRE_ACIT?.EMAIL?.NAME }
                                                                    type="text"
                                                                    value={ formulaireIndemnisation?.[FORMULAIRE_ACIT?.EMAIL?.NAME]?.value }
                                                                    onChange={ handleInput }
                                                                    className='form-control'
                                                                    placeholder={ FORMULAIRE_ACIT?.EMAIL?.PLACEHOLDER }
                                                                />

                                                                { submitted && formulaireIndemnisation?.[FORMULAIRE_ACIT?.EMAIL?.NAME]?.invalid
                                                                    && renderError(formulaireIndemnisation?.[FORMULAIRE_ACIT?.EMAIL?.NAME]?.invalid) }
                                                            </div>
                                                            <div className="col-12">
                                                                { submitted && formulaireIndemnisation?.[FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME]?.invalid
                                                                    && renderError(formulaireIndemnisation?.[FORMULAIRE_ACIT?.NEW_COORDONNEES?.NAME]?.invalid) }
                                                            </div>
                                                        </div>
                                                    </>
                                                ) }
                                            </>
                                        ) }
                                    </div>
                                </div>
                            </div>

                            <div className='mt-3'>
                                <h3>Contrats :</h3>

                                <div className='col-lg-6'>
                                    <div className="row">

                                        <div className='col-6'>
                                            <label
                                                className='label'
                                                htmlFor={ FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME }>
                                                { `Date de l'arrêt de travail initial :` }
                                            </label>
                                        </div>
                                        <div className='col-2'>
                                            <InfoBulle
                                                info={ `Date du 1er jour d'indemnisation à plein traitement par l'employeur` }/>
                                        </div>

                                    </div>
                                    <div className="col-lg-4">
                                        <input
                                            id={ FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME }
                                            name={ FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME }
                                            className='form-control'
                                            value={ formulaireIndemnisation?.[FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]?.value }
                                            onChange={ handleInput }
                                            disabled={ isComplement || isSuite }
                                            type="date"/>
                                    </div>

                                    <div className="col-12">
                                        { submitted && formulaireIndemnisation?.[FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]?.invalid
                                            && renderError(formulaireIndemnisation?.[FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]?.invalid) }
                                    </div>
                                </div>

                                { submitted && !isComplement && !checkForNewValidContratsPeriode(periodesContrats) && (
                                    <div className="row">
                                        <div className="col">
                                            { renderError("Vous devez saisir au moins une nouvelle période sur l'un de vos contrats") }
                                        </div>
                                    </div>
                                ) }

                                <div className='row mt-3'>

                                    {/* TODO Faire un else par défaut */ }
                                    { detailPersonne?.contrat?.length > 0 && detailPersonne?.contrat.map(contratElement => {

                                        const contratsSuiteComp = dossier?.formulaire?.beneficiaire?.contrats
                                        const contratSuiteComp = contratsSuiteComp?.find(({ numero }) => numero === contratElement?.numeroContrat)

                                        const sortedPeriodes = sortPeriodesDescending(contratSuiteComp?.periodes)

                                        if (formulaireIndemnisation?.[FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]?.value || !isComplement) {

                                            return (
                                                <div className="col-lg-6" key={ contratElement?.numeroContrat }>
                                                    <div className="card h-100 d-flex flex-column">
                                                        <div
                                                            className={ `card-header ${ contratElement?.dateRadiationContrat
                                                                ? 'header-annule' : contratElement?.gammeContrat !== "SANTE"
                                                                    ? "header-rose" : '' }` }>
                                                            <h4>{ contratElement?.gammeContrat } - { contratElement?.nomProduit }</h4>
                                                            <h5> Numéro de contrat
                                                                : { contratElement?.numeroContrat }</h5>

                                                            { contratElement?.dateRadiationContrat && (
                                                                <div className='float-end'>Contrat résilié au
                                                                    : { contratElement?.dateRadiationContrat }</div>
                                                            ) }
                                                        </div>

                                                        <div className="card-body">
                                                            <h6>
                                                                { contratElement?.gammeContrat === "SANTE" ? "Allocations Complémentaires" : 'Incapacité Temporaire' }
                                                            </h6>

                                                            { periodesContrats?.[contratElement?.numeroContrat]?.periodes?.length > 0
                                                            && formulaireIndemnisation?.[FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]?.value
                                                            && !isComplement
                                                                ? (
                                                                    <div key={ contratElement?.numeroContrat }>
                                                                        <div className='form-label mt-3'>
                                                                            Période à indémniser par la MNH :
                                                                        </div>
                                                                        { periodesContrats?.[contratElement?.numeroContrat]?.periodes.map((periode, index) => {

                                                                            const { isIncompletePeriode, isInvalidDate } = checkIncompletePeriode(periode)

                                                                            return (
                                                                                <div className="row mt-3"
                                                                                     key={ `${ contratElement?.numeroContrat }-${ index }` }>
                                                                                    <div className="col-lg-5">
                                                                                        <label
                                                                                            className="form-label"
                                                                                            htmlFor={ `dateIndemnisationDebut-${ contratElement?.numeroContrat }-${ index }` }>
                                                                                            Date début :
                                                                                        </label>
                                                                                        <input
                                                                                            id={ `dateIndemnisationDebut-${ contratElement?.numeroContrat }-${ index }` }
                                                                                            name={ 'dateIndemnisationDebut' }
                                                                                            onChange={ (e) => handlePeriode(e, index, contratElement?.numeroContrat) }
                                                                                            className='form-control'
                                                                                            min={ formulaireIndemnisation?.[FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]?.value }
                                                                                            type="date"/>
                                                                                    </div>
                                                                                    <div className="col-lg-5">
                                                                                        <label
                                                                                            className="form-label"
                                                                                            htmlFor={ `dateIndemnisationFin-${ contratElement?.numeroContrat }-${ index }` }>
                                                                                            Date fin :
                                                                                        </label>
                                                                                        <input
                                                                                            id={ `dateIndemnisationFin-${ contratElement?.numeroContrat }-${ index }` }
                                                                                            name={ 'dateIndemnisationFin' }
                                                                                            onChange={ (e) => handlePeriode(e, index, contratElement?.numeroContrat) }
                                                                                            className='form-control'
                                                                                            min={ periode?.dateIndemnisationDebut?.value ?? formulaireIndemnisation?.[FORMULAIRE_ACIT?.DATE_ARRET_TRAVAIL_INITIAL?.NAME]?.value }
                                                                                            type="date"/>
                                                                                    </div>

                                                                                    <div
                                                                                        className="col-lg-2 d-flex align-items-end">
                                                                                        { index !== 0 && (
                                                                                            <button
                                                                                                onClick={ () => deletePeriode(index, contratElement?.numeroContrat) }
                                                                                                type="button"
                                                                                                className="btn btn-secondary px-1">
                                                                                                Supp
                                                                                            </button>
                                                                                        ) }
                                                                                    </div>

                                                                                    <div className="col-12">
                                                                                        { submitted && isIncompletePeriode
                                                                                            && renderError("Les périodes doivent avoir une date de début et de fin") }
                                                                                    </div>
                                                                                    <div className="col-12">
                                                                                        { submitted && isInvalidDate
                                                                                            && renderError("Date invalide") }
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }) }

                                                                        { periodesContrats?.[contratElement?.numeroContrat]?.isOverlapping && (
                                                                            renderError("Vous ne pouvez pas avoir de recoupement entre les périodes")
                                                                        ) }

                                                                        <div
                                                                            className="mt-3 d-flex justify-content-end">
                                                                            <button
                                                                                onClick={ () => addPeriode(contratElement?.numeroContrat) }
                                                                                type="button"
                                                                                className="btn btn-primary px-1">
                                                                                Ajouter période
                                                                            </button>
                                                                        </div>

                                                                    </div>
                                                                ) : (
                                                                    <div>
                                                                        Veuillez renseigner une date d'arrêt de travail initial
                                                                    </div>
                                                                )}

                                                            { ((isComplement || isSuite) && contratSuiteComp?.periodes?.length > 0) && (
                                                                <div>
                                                                    <div className='form-label mt-3'>
                                                                        Période à indémniser par la MNH renseigné
                                                                        précédemment :
                                                                    </div>


                                                                    <PaginationWithTable
                                                                        records={ contratSuiteComp?.periodes }
                                                                        recordsPerPage={ 4 }
                                                                        TableComponent={ BuildPeriodesTable }
                                                                    />
                                                                </div>
                                                            ) }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    }) }
                                </div>
                            </div>

                            <div className='mt-3'>
                                <h3>Ajout de pièces jointes :</h3>
                                {/*TODO variabiliser*/ }
                                <div className="row">
                                    <div className="col-lg-4 mt-2">
                                        <label htmlFor="bulletinSalaire" className="form-label">
                                            Bulletin de salaire :
                                        </label>
                                        <input
                                            id="bulletinSalaire"
                                            name="formFile"
                                            className="form-control"
                                            type="file"
                                            multiple
                                            onChange={ handleFileChange }
                                        />
                                    </div>
                                    <div className="col-lg-4 mt-2">
                                        <label htmlFor="historiquePaie" className="form-label">
                                            Historique de paie :
                                        </label>
                                        <input
                                            id="historiquePaie"
                                            name="formFile"
                                            className="form-control"
                                            type="file"
                                            multiple
                                            onChange={ handleFileChange }
                                        />
                                    </div>
                                    <div className="col-lg-4 mt-2">
                                        <label htmlFor="decisionCommiteMedical" className="form-label">
                                            Décision du Comité médical :
                                        </label>
                                        <input
                                            id="decisionCommiteMedical"
                                            name="formFile"
                                            className="form-control"
                                            type="file"
                                            multiple
                                            onChange={ handleFileChange }
                                        />
                                    </div>
                                    <div className="col-lg-4 mt-2">
                                        <label htmlFor="arretTravail" className="form-label">
                                            Arrêt de travail :
                                        </label>
                                        <input
                                            id="arretTravail"
                                            name="formFile"
                                            className="form-control"
                                            type="file"
                                            multiple
                                            onChange={ handleFileChange }
                                        />
                                    </div>
                                    <div className="col-lg-4 mt-2">
                                        <label htmlFor="releveAbsence" className="form-label">
                                            Relevé d'absentéisme :
                                        </label>
                                        <input
                                            id="releveAbsence"
                                            name="formFile"
                                            className="form-control"
                                            type="file"
                                            multiple
                                            onChange={ handleFileChange }
                                        />
                                    </div>
                                    <div className="col-lg-4 mt-2">
                                        <label htmlFor="autre" className="form-label">
                                            Autre :
                                        </label>
                                        <input
                                            id="autre"
                                            name="formFile"
                                            className="form-control"
                                            type="file"
                                            multiple
                                            onChange={ handleFileChange }
                                        />
                                    </div>
                                </div>

                                { submitted && invalidPj && renderError(invalidPj) }


                                <div className='mt-3'>
                                    <h3>Documents ajoutés :</h3>

                                    {/* key={selectedFiles.length} Sert à forcer le rerendu */}
                                    <PaginationWithTable
                                        key={ selectedFiles.length }
                                        records={ selectedFiles }
                                        recordsPerPage={ 5 }
                                        TableComponent={ DocumentsTable }
                                    />
                                </div>


                            </div>
                        </div>

                        <div className="px-3">
                            { submitted && invalidDossier && renderError(ErrorFormulaire)}
                        </div>


                        <div className="card-footer mt-3">
                            <div
                                className='d-flex justify-content-end'>
                                <button
                                    className="btn btn-primary"
                                    type="submit"
                                    disabled={ !infosCorrespondant }

                                >
                                    { isComplement ? 'Envoyer le complément' : isSuite ? 'Envoyer la suite' : 'Envoyer dossier' }
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </main>

            <Modal
                show={ showEnvoiModal }
            >
                <Modal.Header>

                    <h3>
                        { modaleEnvoiFichier?.label }{ modaleEnvoiFichier?.etape }/3
                    </h3>
                </Modal.Header>

                <Modal.Body>

                    <div>
                        Statut formulaire : { modaleEnvoiFichier?.appel1?.label }
                        { modaleEnvoiFichier?.appel1?.error && (
                            <div className={ 'pink-text' }>
                                { modaleEnvoiFichier?.appel1?.error }
                            </div>
                        ) }
                    </div>

                    <div>
                        Statut des pièces jointes : { modaleEnvoiFichier?.appel2?.label }

                        { modaleEnvoiFichier?.appel2?.error > 0 && (
                            <div className={ 'pink-text' }>
                                Echec de l'envoi de
                                : { modaleEnvoiFichier?.appel2?.error } { modaleEnvoiFichier?.appel2?.error > 1 ? "pièces jointes" : "pièce jointe" }
                            </div>
                        ) }
                    </div>

                    <div>
                        Statut de la demande : { modaleEnvoiFichier?.appel3?.label }
                    </div>
                    { modaleEnvoiFichier?.appel3?.error && (
                        <div className={ 'pink-text' }>
                            { modaleEnvoiFichier?.appel3?.error }
                        </div>
                    ) }

                </Modal.Body>

                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        // onClick={ () => setShowEnvoiModal(false) }
                        onClick={ () => navigate(ROUTES?.PAGES?.DEMANDE_INDEMNISATION?.LISTE_INDEMNISATION) }
                    >
                        Retourner à la liste des demandes
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}